import { Parser } from "@siteimprove/alfa-parser";
import { Function as CSSFunction } from "../../syntax/index.js";
import { List } from "../collection/index.js";
import { Angle, Number } from "../numeric/index.js";
import { Function } from "./function.js";
const { map, either } = Parser;
/**
 * @public
 */
export class Skew extends Function {
    static of(x, y) {
        return new Skew(x.resolve(), y.resolve());
    }
    _x;
    _y;
    constructor(x, y) {
        super("skew", false);
        this._x = x;
        this._y = y;
    }
    get x() {
        return this._x;
    }
    get y() {
        return this._y;
    }
    resolve() {
        return this;
    }
    equals(value) {
        return (value instanceof Skew &&
            value._x.equals(this._x) &&
            value._y.equals(this._y));
    }
    hash(hash) {
        hash.writeHashable(this._x).writeHashable(this._y);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            x: this._x.toJSON(),
            y: this._y.toJSON(),
        };
    }
    toString() {
        if (this._y.value === 0) {
            return `skewX(${this._x})`;
        }
        if (this._x.value === 0) {
            return `skewY(${this._y})`;
        }
        return `skew(${this._x}, ${this._y})`;
    }
}
/**
 * @public
 */
(function (Skew) {
    function isSkew(value) {
        return value instanceof Skew;
    }
    Skew.isSkew = isSkew;
    const _0 = Angle.of(0, "deg");
    const parseAngleOrZero = either(Angle.parse, map(Number.parseZero, () => _0));
    /**
     * {@link https://drafts.csswg.org/css-transforms/#funcdef-transform-skew}
     */
    const parseSkew = map(CSSFunction.parse("skew", map(List.parseCommaSeparated(parseAngleOrZero, 1, 2), (list) => list.values)), ([_, [x, y]]) => Skew.of(x, y ?? _0));
    /**
     * {@link https://drafts.csswg.org/css-transforms/#funcdef-transform-skewx}
     */
    const parseSkewX = map(CSSFunction.parse("skewX", parseAngleOrZero), ([_, x]) => Skew.of(x, _0));
    /**
     * {@link https://drafts.csswg.org/css-transforms/#funcdef-transform-skewy}
     */
    const parseSkewY = map(CSSFunction.parse("skewY", parseAngleOrZero), ([_, y]) => Skew.of(_0, y));
    Skew.parse = either(parseSkew, parseSkewX, parseSkewY);
})(Skew || (Skew = {}));
//# sourceMappingURL=skew.js.map